export default "__VITE_ASSET__DQLg2FsL__"